// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"0c53c7f1","391":"59f0a514","455":"e021a6ef","488":"1a9a8f8c","685":"729ef1fc","695":"00c5b50c","977":"3d2c2926"}[chunkId] + ".chunk.js";
};